import { useEffect, useState } from 'react';
import { data_from_server_post } from '@/shared/http/client';

/**
 * Upload names behind the tab's rows, powering the Data Editor's Sample
 * Origin checkbox column filter.
 *
 * Auto-split outputs (`*_train` / `*_bench`) list the uploads they were carved
 * from, so the options name the original files rather than the live
 * collections. Fetched lazily while the column is visible (`enabled`) and
 * re-fetched when the task, the tab, or the tab's dataset list changes
 * (e.g. right after training promotes the split).
 */
export function useSampleOriginFilterValues(currentUsecase, isBenchmark, enabled) {
    const [values, setValues] = useState([]);
    const clientId = currentUsecase?.client_id;
    const usecaseId = currentUsecase?._id;
    const tabDatasets = isBenchmark ? currentUsecase?.benchmarks : currentUsecase?.datasets;
    const tabSignature = Array.isArray(tabDatasets) ? tabDatasets.join('\u0000') : '';

    useEffect(() => {
        if (!enabled || !clientId || !usecaseId) return undefined;
        let cancelled = false;
        data_from_server_post(
            'dataset-records/sample-origins',
            {
                client_id: clientId,
                llm_usecase_id: usecaseId,
                is_benchmark: Boolean(isBenchmark),
            },
            (result) => {
                if (cancelled) return;
                setValues(Array.isArray(result?.values) ? result.values : []);
            },
            () => {
                if (cancelled) return;
                setValues([]);
            }
        );
        return () => {
            cancelled = true;
        };
    }, [enabled, clientId, usecaseId, isBenchmark, tabSignature]);

    return values;
}
